import React from "react";

const elevationShadow = {
  0: "shadow-none",
  1: "shadow-sm",
  2: "shadow-sm",
  3: "shadow-md",
  4: "shadow-lg",
};

const Paper = React.forwardRef(
  (
    {
      variant = "elevation",
      elevation = 1,
      square = false,
      className = "",
      children,
      ...rest
    },
    ref
  ) => {
    const border = variant === "outlined" ? "border border-farmazon-border" : "";
    const shadow =
      variant === "outlined" ? "" : elevationShadow[elevation] ?? "shadow-md";
    const radius = square ? "" : "rounded-lg";

    return (
      <div
        ref={ref}
        className={`bg-farmazon-surface text-farmazon-text ${border} ${shadow} ${radius} ${className}`}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default Paper;
